import React from 'react';
import PropTypes from 'prop-types';
import control from '../../hocs/control/index';
import {noop} from 'lodash';
import Datetime from 'react-datetime';
//https://github.com/Lesha-spr/react-validation
class DatePicker extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    const { error, isUsed, onChange,onBlur, ...props } = this.props;
    let className = '';

    if (isUsed) {
      if (error) {
        className = `is-invalid-input ${props.className}`;
      } else {
        className = `is-valid-input ${props.className}`;
      }
    } else {
      className = `${props.className}`;
    }

    var id = 'vali-' + props.name;

    let { value, defaultValue } = props;

    if (defaultValue && (value === null || value === '')) {
      value = defaultValue;
    }

    return <div style={this.props.divStyle}>
      <Datetime
        {...props}
        {...({ className: `${className}` }) }
        value={value}
        inputProps={{ placeholder: 'MM/DD/YYYY' }}
        timeFormat={false}
        onChange={(data) => onChange({persist: noop, target: {value: data} })}
        onBlur={(data) => onBlur({persist: noop, target: {value: data} })}
        dateFormat='MM/DD/YYYY'
        closeOnSelect={true}/>
      {isUsed && error && <span id={id} className='cls-danger help-block' style={{marginBottom: -15}}>{error} </span>}
    </div>;
  }
}

DatePicker.propTypes = {
  error: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
  name: PropTypes.string,
  isUsed: PropTypes.bool,
  divStyle: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};

export default control(DatePicker);



// WEBPACK FOOTER //
// ./src/components/react-validation/components/datepicker/index.js